import React, { useEffect } from 'react'

import WindowLocation from 'helpers/windowLocation'

import useCognitoAuthToken from 'hooks/useCognitoAuthToken'

import Api from 'services/api'

import { NoData, SinglePanePage, screenSize } from 'styles/shared'
import { color } from 'styles/colors'

import Brand from 'helpers/brand'

import styled from 'styled-components'

const SIGNOUT_TIMEOUT = 30

const SignInError = () => {
  const { authToken, isAuthTokenLoaded } = useCognitoAuthToken()

  useEffect(() => {
    if (!isAuthTokenLoaded || !authToken) return

    const timeoutId = window.setTimeout(() => {
      WindowLocation.replace(Api.Session.logout(authToken))
    }, SIGNOUT_TIMEOUT * 1000)

    return () => clearTimeout(timeoutId)
  }, [authToken, isAuthTokenLoaded])

  const onClickLoginLink = () => {
    if (!authToken) return

    WindowLocation.replace(Api.Session.logout(authToken))
  }

  if (!isAuthTokenLoaded) {
    return null
  }

  return (
    <S.PaneContainer>
      <SinglePanePage>
        <S.ProductLogo src={Brand.productLogoPath()} aria-label="product-logo" alt={`${Brand.productName()} logo`} />
        <NoData>
          <h1>Failed to Login</h1>
          <h2>Please try again or call support at 844-359-0270 for assistance.</h2>
          {!authToken && (
            <S.NoTokenText>
              Unexpected error occurred. Failed to retrieve authentication token.
            </S.NoTokenText>
          )}

          {authToken && (
            <h2>
              You will soon be redirected to the <S.LoginPageLink onClick={onClickLoginLink}>Login Page.</S.LoginPageLink>
            </h2>
          )}
        </NoData>
        <S.BrandLogo src={Brand.brandLogoPath()} aria-label="brand-logo" alt={`${Brand.brandLogoPath()} logo`} />
      </SinglePanePage>
    </S.PaneContainer>
  )
}

const S = {
  PaneContainer: styled.div`
    background-color: ${color('background')};
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 100%;
  `,
  SinglePanePage: styled(SinglePanePage)`
    margin-top: 40px;

    @media ${screenSize.small} {
      margin: 20px;
      border-radius: 16px;
    }
  `,
  LoginPageLink: styled.a`
    color: ${color('anchor')};
    text-decoration: none;
    cursor: pointer;
  `,
  NoTokenText: styled.h2`
    margin-top: 20px;
    color: ${color('errorText')} !important;
  `,
  Header: styled.div`
    background-color: ${color('paneBackground')};
  `,
  ProductLogo: styled.img`
    height: 33px;
    float: right;
  `,
  BrandLogo: styled.img`
    height: 40px;
  `
}

export default SignInError
